export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img3-8e0e91a1a11766938c9044f3461b1f05.png";